"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgendaStyle = void 0;
var AgendaStyle;
(function (AgendaStyle) {
    AgendaStyle["STANDARD"] = "Standard";
    AgendaStyle["RANDOM"] = "Random";
    AgendaStyle["CHAIRMAN"] = "Chairman";
})(AgendaStyle = exports.AgendaStyle || (exports.AgendaStyle = {}));
